<i18n src="./resources/locales.json"></i18n>

<template>
  <EcsSideBarWrapper
    class="supervisor-side-bar"
    :search-placeholder="$t('placeholder')"
    sync-search
    @search-input-changed="handleSearch"
  >
    <v-row no-gutters>
      <v-col>
        <!-- Pending interactions -->
        <EcsSideBarInteractionList
          v-if="displayPendingInteraction"
          :header="$t('pendingInteractions')"
          :interactions="getPendingInteractions"
          is-pending
          show-counter
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col>
        <EcsSideBarTileContent :header="$t('dashboard')">
          <v-list-item
            v-for="dashboard in filteredSupervisorDashboards"
            :key="dashboard.key"
            :class="{ active: selectedSupervisorDashboard === dashboard.key }"
            @click="setSelectedSupervisorDashboard(dashboard.key)"
          >
            <v-list-item-content>
              <v-list-item-title v-once>{{ $t(`dashboards.${dashboard.key}`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </EcsSideBarTileContent>
      </v-col>
    </v-row>
  </EcsSideBarWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EcsSideBarPendingInteractionMixin from '@/mixins/ecs-side-bar-pending-interaction-mixin/EcsSideBarPendingInteractionMixin';
import EcsSideBarInteractionMixins from '@/mixins/ecs-side-bar-interaction-mixins/EcsSideBarInteractionMixins';

export default {
  name: 'EcsDashboardSupervisorSideBar',

  mixins: [EcsSideBarInteractionMixins, EcsSideBarPendingInteractionMixin],

  computed: {
    ...mapGetters('DASHBOARD', ['supervisorDashboards', 'selectedSupervisorDashboard']),

    filteredSupervisorDashboards() {
      return this.supervisorDashboards.filter(dashboard =>
        this.$t(`dashboards.${dashboard.key}`)
          .toLowerCase()
          .includes(this.searchString.toLowerCase())
      );
    }
  },

  methods: {
    ...mapActions('DASHBOARD', ['setSelectedSupervisorDashboard'])
  }
};
</script>

<style scoped>
.v-list-item.active,
.v-list-item:hover {
  background-color: var(--v-hover-background);
}
</style>
